export default {
	"Coupon.CouponsAreAvailable": "Coupons are available"
}